// @ts-nocheck
import {
    productListFilterAccordionSectionStyles,
    ProductListFilterAccordionSectionStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { accordionFilterSectionProps } from "@store/Themes/common/props/accordionFilter";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const linkProps = {
    css: css`
        ${linkActionStyles()}
        ${spacingStyles(pxToRem(14), null)}
    `,
};

Object.assign(productListFilterAccordionSectionStyles, {
    accordionSection: accordionFilterSectionProps,
    checkBoxGroup: {
        css: spacingStyles(pxToRem(14), null),
    },
    checkBox: {},
    checkBoxSelected: {},
    seeAllLink: linkProps,
    seeLessLink: linkProps,
} as ProductListFilterAccordionSectionStyles);
